import { type EnvironmentDetailResponse, templateStanding } from "@starsach/shared-types";
import { Card, RelativeTime, StatusPill } from "../../components/ui";

/**
 * Phase 7 "self-service onboarding": what a customer sees on their own
 * account until the stack has reported in. The same facts internal-team
 * reads from the header, framed as the next thing to do.
 */
export function OnboardingPanel({ detail }: { detail: EnvironmentDetailResponse }) {
  const c = detail.customer;
  const steps: Array<{ label: string; done: boolean; hint: string }> = [
    { label: "Deploy the Gairm template in your AWS account", done: Boolean(c.connectivity_verified_at), hint: "Your Gairm contact provides the template and your API key. The stack finishes only once it has reached Gairm." },
    { label: "First heartbeat received", done: Boolean(c.last_heartbeat_at), hint: "Arrives within an hour of the stack completing." },
    { label: "Running the current template version", done: ["current", "ahead"].includes(templateStanding(c.template_version, detail.currentTemplateVersion)), hint: c.template_version ? `You are on ${c.template_version}; current is ${detail.currentTemplateVersion}.` : "Reported with the first heartbeat." },
  ];
  const remaining = steps.filter((s) => !s.done).length;
  return (
    <Card title="Getting connected" className="mb-6">
      <ol className="space-y-3">
        {steps.map((s, i) => (
          <li key={s.label} className="flex gap-3">
            <span className="mt-0.5"><StatusPill status={s.done ? "done" : `step ${i + 1}`} tone={s.done ? "ok" : "warning"} /></span>
            <div>
              <p className="font-medium">{s.label}</p>
              <p className="text-sm text-neutral-600 dark:text-neutral-400">{s.hint}</p>
            </div>
          </li>
        ))}
      </ol>
      <p className="mt-3 text-sm text-neutral-600 dark:text-neutral-400">
        {remaining === 0 ? <>All set - connected <RelativeTime iso={c.connectivity_verified_at} />.</> : `${remaining} step${remaining === 1 ? "" : "s"} remaining.`}
      </p>
    </Card>
  );
}
